    /*
 * Simple javascript code to power a collapsable faq list
 */
$(function () {

  var collapsable = $('.js-collapsable');
  var items = collapsable.find('[data-toggle=collapse]');

  items.on('click', function (evt) {
    evt.preventDefault();
    var curr = collapsable.find('.collapsed.in');
    var target = $(this).parent().next('.collapsed');

    curr.removeClass('in');
    if (target.get(0) !== curr.get(0)) {
      $(this).parent().next('.collapsed').addClass('in');
    }
  });

});

//# sourceMappingURL=maps/collapsable.js.map